module.exports = __webpack_public_path__ + "static/media/homepage-slider-1.e9f4dd03.png";